export type { FlexProps } from './Flex'
export { Flex } from './Flex'
